import { useBreakpoints, useCssVar } from '@vueuse/core';
import { computed } from 'vue';

const rootHtml = document.documentElement;

/** Lista breakpointów z `variables.css` */
const breakpoints = useBreakpoints({
  xs: useCssVar('--breakpoint-xs', rootHtml).value || '',
  sm: useCssVar('--breakpoint-sm', rootHtml).value || '',
  md: useCssVar('--breakpoint-md', rootHtml).value || '',
  lg: useCssVar('--breakpoint-lg', rootHtml).value || '',
  xl: useCssVar('--breakpoint-xl', rootHtml).value || '',
  xxl: useCssVar('--breakpoint-xxl', rootHtml).value || ''
});

/** Breakpoint */
export const breakpoint = computed(() => {
  return {
    xs: breakpoints.smaller(Breakpoints.sm).value,
    sm: breakpoints.smaller(Breakpoints.md).value,
    md: breakpoints.smaller(Breakpoints.lg).value,
    lg: breakpoints.smaller(Breakpoints.xl).value,
    xl: breakpoints.smaller(Breakpoints.xxl).value,
    xxl: true
  };
});

/** Dokładny breakpoint */
export const exactBreakpoint = computed(() => {
  if (breakpoint.value.xs) {
    return Breakpoints.xs;
  }

  if (breakpoint.value.sm) {
    return Breakpoints.sm;
  }

  if (breakpoint.value.md) {
    return Breakpoints.md;
  }

  if (breakpoint.value.lg) {
    return Breakpoints.lg;
  }

  if (breakpoint.value.xl) {
    return Breakpoints.xl;
  }

  if (breakpoints.greater(Breakpoints.xl).value) {
    return Breakpoints.xxl;
  }
  return;
});

/**
 * Dostępne breakpointy
 *
 * @export
 * @enum {number}
 */
export enum Breakpoints {
  lg = 'lg',
  md = 'md',
  sm = 'sm',
  xl = 'xl',
  xs = 'xs',
  xxl = 'xxl',
  xxxl = 'xxxl'
}
